export const gridViewConnectorFilterType = Object.freeze({
	Parent: 0,
	Child: 1,
});
